import FieldProto from "../../../proto/field-proto";
import FieldConfig from "../../../proto/field-config";
import FieldTotal_ViewSmall from "./render/view-small";
import FieldTotal_View from "./render/view";

// proto for all types of counters

export default class FieldTotal extends FieldProto {

    FIELD_DEFAULT_WIDTH = 100;

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "total"
        this.icon               = 'i5-id';

        this.isSearchable       = false;

        // this.formType           = false;

        _.assign(this.renderComponents,{
            view                : FieldTotal_View,
            viewSmall           : FieldTotal_ViewSmall
        })
    }

    access(model: any): "read" | "write" | false {
        return 'read'
    }

    /*** DATA FUNCTIONS ***/

    sortValue(value:any) { return value ? value: 0; }

    searchValue(value:any) { return value ? value : ''; }

    getViewValue(model:any) {
        return model[this.fieldId];
    }




}
